import React from 'react'
import moment from 'moment/moment'
import { TraceSummarySingleView } from '../../../domain/TraceSummary'
import { now } from 'moment'

interface Props {
    duration: number
    traceSummary: TraceSummarySingleView
}

class ShareTraceExpirationDate extends React.Component<Props> {
    public render = (): React.ReactNode => {
        return (
            <span className="input-group-addon">
                {this.renderShareOrShared()} {this.renderSharedUntilDate(this.getSharedUntilDate())}
            </span>
        )
    }

    private getSharedUntilDate = (): string | null => {
        if (this.props.traceSummary.sharedTraceInfo && this.props.traceSummary.hasActiveShare) {
            return this.props.traceSummary.sharedTraceInfo.sharedUntil
        }

        return this.props.duration === 0 ? null : this.getNowPlusDays(this.props.duration)
    }

    private renderSharedUntilDate = (date: string | null): string => {
        if (date === null) {
            return 'indefinitely'
        }

        return (
            'until ' +
            moment
                .utc(date)
                .local()
                .format('YYYY-MM-DD HH:mm')
        )
    }

    private renderShareOrShared = (): string => {
        return this.props.traceSummary.hasActiveShare ? 'shared' : 'share'
    }

    private getNowPlusDays = (days: number): string => {
        return moment(now())
            .add(days, 'days')
            .utc()
            .format('YYYY-MM-DD HH:mm')
    }
}

export default ShareTraceExpirationDate
